<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">现货委托管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>止盈止损</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <div class="select">
          <el-input v-model="filters.orderId" clearable size="mini" class="item" placeholder="订单ID"
            @keyup.enter.native="handleSearch" />
          <el-input v-model="filters.accountId" clearable size="mini" class="item" placeholder="账户ID"
            @keyup.enter.native="handleSearch" />
          <el-select v-model="filters.symbolId" clearable filterable size="mini" class="item symbol-select"
            placeholder="选择币种">
            <el-option v-for="item in pairList" :key="item.id" :label="item.symbol" :value="item.id" />
          </el-select>
          <el-select v-model="filters.status" clearable size="mini" class="item status-select" placeholder="选择状态">
            <el-option v-for="item in statusOptions" :key="String(item.value)" :label="item.label"
              :value="item.value" />
          </el-select>
          <el-date-picker v-model="filters.createdRange" type="daterange" size="mini" class="item date-range"
            align="right" format="yyyy-MM-dd" value-format="yyyy-MM-dd" unlink-panels range-separator="-"
            start-placeholder="开始时间" end-placeholder="结束时间" />
          <el-button size="mini" type="primary" @click="handleSearch">搜索</el-button>
        </div>
      </div>

      <el-table :data="tableList" size="small" border height="calc(100vh - 320px)" v-loading="loading">
        <el-table-column label="用户ID" prop="userId" min-width="120" fixed>
          <template slot-scope="scope">
            {{ displayUserId(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="订单ID" prop="orderId" min-width="140" />
        <el-table-column label="币种" prop="symbol" min-width="100" />
        <el-table-column label="委托数量" min-width="130">
          <template slot-scope="scope">
            {{ formatQty(scope.row.quantity, scope.row.symbol) }}
          </template>
        </el-table-column>
        <el-table-column label="触发价格(USDT)" min-width="130">
          <template slot-scope="scope">
            {{ formatPrice(scope.row.triggerPrice) }}
          </template>
        </el-table-column>
        <el-table-column label="止盈/止损" min-width="190" align="center">
          <template slot-scope="scope">
            <div>{{ formatPrice(getTakeProfitPrice(scope.row)) }} / {{ formatPrice(getStopLossPrice(scope.row)) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="已成交数量" min-width="130">
          <template slot-scope="scope">
            {{ formatQty(scope.row.executedQuantity, scope.row.symbol) }}
          </template>
        </el-table-column>
        <el-table-column label="成交均价" min-width="110">
          <template slot-scope="scope">
            {{ formatPrice(scope.row.avgPrice) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="100">
          <template slot-scope="scope">
            {{ formatStatus(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
      </el-table>

      <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged" />
    </el-card>
  </div>
</template>

<script>
import Pagination from 'components/pagination';
import moment from 'moment';
import api from './api';
import { PAGINATION } from './constants';

function createFilters() {
  return {
    orderId: '',
    accountId: '',
    symbolId: '',
    status: '',
    createdRange: [],
  };
}

export default {
  name: 'OrderLimitSpotTpsl',
  components: { Pagination },
  data() {
    return {
      loading: false,
      filters: createFilters(),
      statusOptions: [{ label: '全部状态', value: '' }],
      statusMap: {},
      pairList: [],
      tableList: [],
      totalCount: 0,
      pagination: { ...PAGINATION },
    };
  },
  mounted() {
    this.loadStatusOptions();
    this.loadPairList();
    this.fetchList();
  },
  methods: {
    normalizeStatusItem(item) {
      if (!item || item.status == null || !item.statusName) return null;
      return { value: item.status, label: item.statusName };
    },
    loadStatusOptions() {
      api.getTpslStatuses().then((res) => {
        if (!res || res.code !== 0) return;
        const raw = res.data || res.result || [];
        const list = Array.isArray(raw) ? raw : [];
        const options = [{ label: '全部状态', value: '' }];
        const map = {};
        list.forEach((item) => {
          const normalized = this.normalizeStatusItem(item);
          if (!normalized) return;
          options.push(normalized);
          map[normalized.value] = normalized.label;
        });
        this.statusOptions = options;
        this.statusMap = map;
      });
    },
    loadPairList() {
      api.getPairList().then((res) => {
        if (res && res.code === 0) {
          this.pairList = res.data || [];
        }
      });
    },
    buildQuery(extra = {}) {
      const query = {
        page: this.pagination.page,
        size: this.pagination.size,
        ...extra,
      };
      if (this.filters.orderId) {
        query.orderId = this.filters.orderId;
      }
      if (this.filters.accountId) {
        query.accountId = Number(this.filters.accountId);
      }
      if (this.filters.symbolId !== '' && this.filters.symbolId != null) {
        query.symbolId = Number(this.filters.symbolId);
      }
      if (this.filters.status !== '' && this.filters.status != null) {
        query.status = this.filters.status;
      }
      if (this.filters.createdRange && this.filters.createdRange.length === 2) {
        query.startTime = moment(this.filters.createdRange[0])
          .startOf('day')
          .valueOf();
        query.endTime = moment(this.filters.createdRange[1])
          .endOf('day')
          .valueOf();
      }
      return query;
    },
    fetchList(extra = {}) {
      this.loading = true;
      api
        .getTpslPage(this.buildQuery(extra))
        .then((res) => {
          if (res && res.code === 0) {
            const d = res.data || {};
            this.tableList = d.list || d.items || d.records || [];
            this.totalCount =
              d.totalCount != null
                ? d.totalCount
                : d.total != null
                  ? d.total
                  : 0;
          } else {
            this.tableList = [];
            this.totalCount = 0;
            this.$message.error((res && res.msg) || '查询失败');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.pagination = { ...PAGINATION };
      this.fetchList();
    },
    pageChanged(pagination) {
      this.pagination = pagination;
      this.fetchList();
    },
    displayUserId(row) {
      return row.userId != null && row.userId !== ''
        ? row.userId
        : row.accountId != null
          ? row.accountId
          : '--';
    },
    getTakeProfitPrice(row) {
      return row.takeProfitTriggerPrice || '--';
    },
    getStopLossPrice(row) {
      return row.stopLossTriggerPrice || '--';
    },
    formatPrice(val) {
      if (val == null || val === '') return '--';
      return val;
    },
    formatQty(qty, symbol) {
      if (qty == null || qty === '') return '--';
      const coin = this.extractBaseCoin(symbol);
      return coin ? `${qty} ${coin}` : qty;
    },
    extractBaseCoin(symbol) {
      if (!symbol) return '';
      const s = String(symbol).toUpperCase();
      if (s.includes('_')) return s.split('_')[0];
      if (s.includes('/')) return s.split('/')[0];
      if (s.endsWith('USDT') && s.length > 4) return s.slice(0, -4);
      return s;
    },
    formatStatus(row) {
      if (row.statusName) return row.statusName;
      if (row.statusDesc) return row.statusDesc;
      return this.statusMap[row.status] || '--';
    },
  },
};
</script>

<style lang="less" scoped>
.page-actions {
  margin-bottom: 12px;
}

.select {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.item {
  width: 160px;
}

.symbol-select,
.status-select {
  width: 140px;
}

.date-range {
  width: 260px !important;
}
</style>
